import html from './footer.html';
import {partial} from '../../../utils/partial';
import {uiContainer, getLanguage} from '../../../configs/global';
import {TweenMax} from 'gsap';
import copyData from '../../../configs/copy';
import Mustache from 'mustache';

/**
 * This is being used as a singleton.
 * There's only one instanced created that is used across all screens.
 * The instance is created in main and passed to all views on init.
 */
export class Footer {
  public element: HTMLElement;
  private copyrightEl: HTMLElement;
  private linksEl: Element[];

  constructor() {
    this.element = partial(Mustache.render(html, copyData[getLanguage()]), 'footer');
    this.render();

    this.copyrightEl = this.element.querySelector('.footer__copyright span');
    this.linksEl = [...this.element.querySelectorAll('.footer__links a')];

    this.presetAnimation();
  }

  private async render() {
    const parent = document.querySelector(uiContainer);
    parent.appendChild(this.element);
  }

  public presetAnimation() {
    TweenMax.set(this.element, {opacity: 0});
    this.element.style.display = `block`;
  }

  /**
   * Progress animation based on a 0-1 value
   * This is used in the scroll-based home render loop
   */
  public step(p: number) {
    let r = 1 - p;
    TweenMax.set(this.element, {opacity: p, y: 10 * r});
  }

  public animateIn(delay = 0) {
    this.element.style.display = `block`;
    return new Promise(resolve => {
      TweenMax.to(this.element, 0.2, {opacity: 1, delay, onComplete: resolve});
    });
  }

  public animateOut(delay = 0) {
    return new Promise(resolve => {
      TweenMax.to(this.element, 0.2, {
        opacity: 0,
        delay,
        onComplete: () => {
          resolve();
          this.element.style.display = `none`;
        }
      });
    });
  }

  public animateToBlack(delay = 0) {
    let duration = 0.5;
    let color = 'rgb(0,0,0)';
    TweenMax.to(this.copyrightEl, duration, {color, delay});
    TweenMax.to(this.linksEl, duration, {color, delay});
  }

  public animateToWhite(delay = 0) {
    let duration = 0.5;
    let color = 'rgb(255,255,255)';
    TweenMax.to(this.copyrightEl, duration, {color, delay});
    TweenMax.to(this.linksEl, duration, {color, delay});
  }

  public show() {
    TweenMax.set(this.element, {opacity: 1});
    this.element.style.display = `block`;
  }

  public hide() {
    TweenMax.set(this.element, {opacity: 0});
    this.element.style.display = `none`;
  }
}
